import { render, staticRenderFns } from "./ProfessionalDevelopment.vue?vue&type=template&id=606e8e28&scoped=true&"
import script from "./ProfessionalDevelopment.vue?vue&type=script&lang=js&"
export * from "./ProfessionalDevelopment.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalDevelopment.vue?vue&type=style&index=0&id=606e8e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606e8e28",
  null
  
)

export default component.exports